"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var LoadingView = function LoadingView() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: LoadingWrapper,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: Wrapper,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: Content,
        children: "Loading"
      })
    })
  });
};

var LoadingWrapper = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
var Wrapper = {
  width: "100%",
  height: "30px",
  margin: "30px 0px",
  textAlign: "center"
};
var Content = {
  display: "inline-block",
  width: "auto",
  height: "24px",
  color: "#3972ff",
  padding: "0 8px",
  borderBottom: "3px solid #3972ff"
};
var _default = LoadingView;
exports.default = _default;